import $ from 'jquery'
import AjaxRequest from "./ajax-request";
import Cookies from 'js-cookie';

class HeaderUserControls {
    constructor(element) {
        this.div = element;
        this.loggedContentUrl = "";
        this.logoutUrl = "";
        this.logoutId = "";
        this.getData();
        this.clearData();
        this.bindEvents();
    }

    getData() {
        this.loggedContentUrl = $(this.div).data("render-logged-content-url");
        this.logoutId = '[data-id="mainheader__logout"]';
    }

    clearData() {
        $(this.div).removeAttr("data-render-logged-content-url");
    }

    bindEvents() {
        let _this = this;
        $(this.div).on("click", this.logoutId, function (event) {
            event.preventDefault();
            _this.doLogout();
        });
        document.addEventListener('user_logged', function () {
            _this.renderLoggedContent();
        });
    }

    doLogout() {
        let _ajaxRequest = new AjaxRequest({
            successCallback: function () {
                Cookies.remove("cs_logged");
                Cookies.remove("cs_adv");
                location.reload();
            }
        });
        _ajaxRequest.makeCall(this.logoutUrl);
    }

    renderLoggedContent() {
        let _ulLinks = $(this.div).find('[data-not-logged]');
        if (_ulLinks.length > 0) {
            let _this = this;
            let _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    let _notLoggedDiv = $(_this.div).find('[data-not-logged]');
                    $(_notLoggedDiv).html(response.message);
                    let _logoutButton = $(_this.div).find('[data-id="mainheader__logout"]');
                    _this.logoutUrl = $(_logoutButton).data("logout-url");
                    $(_logoutButton).removeAttr("data-logout-url");
                    $('body').addClass('is-logged');
                }
            });
            _ajaxRequest.makeCall(this.loggedContentUrl);
        }
    }
}

export default HeaderUserControls;